{
  "locale": "en-CA",
  "global": {
    "site-name": "Project New Home",
    "logo": "projectnewhome.svg"
  },
  "components": {
    "cookie-consent": {
      "title": "Cookie consent",
      "disclaimer": "This site uses cookies to personalize content and analyze web traffic.",
      "learn-more": "Learn more.",
      "accept": "Accept",
      "customize": "Customize",
      "manage": "Manage cookies",
      "preferences": {
        "title": "Cookie preferences",
        "intro": "Choose which categories of cookies you want to allow. Your choice is saved on this device and can be changed at any time.",
        "close": "Close",
        "always-active": "Always active",
        "necessary": {
          "name": "Necessary cookies",
          "description": "Required for the site to work, including navigation and saving your preferences. They cannot be turned off."
        },
        "analytics": {
          "name": "Analytics cookies",
          "description": "Help us understand how the site is used so we can improve its performance and content."
        },
        "marketing": {
          "name": "Marketing cookies",
          "description": "Used to measure the effectiveness of our campaigns and to show you relevant advertising."
        },
        "accept-all": "Accept all",
        "reject-all": "Reject all",
        "save": "Save my choices"
      }
    },
    "language-switcher": {
      "title": "Projet Habitation",
      "content": "Français"
    },
    "new-projects": {
      "header": "Featured Projects",
      "scroll-left": "Scroll Left",
      "scroll-right": "Scroll Right"
    },
    "phone-button": {
      "phone": "Call",
      "phone-with-name": "Call {name}"
    },
    "more-results-button": {
      "text": "See more results"
    },
    "website-button": {
      "website": "Visit Website"
    },
    "range": {
      "to": "to",
      "unlimited": "Unlimited"
    },
    "ad-unit": {
      "advertisement": "Advertisement"
    },
    "subscribe": {
      "title": "Receive new listing alerts",
      "banner-title": "Be the first to know when a new project is listed in this area.",
      "email": "Email",
      "email-placeholder": "Email",
      "button": "Register",
      "privacy-consent": "By subscribing, you agree to receive our newsletters in accordance with our ",
      "privacy-policy": "privacy policy",
      "success": "Registration successful!",
      "error": "There was a server error. Please try again later.",
      "location-error": "The subscription area could not be prepared. Please reload the page and try again.",
      "email-sent": "An email has been sent to you."
    },
    "turnstile-modal": {
      "title": "Verify you're human",
      "description": "Please complete the verification to subscribe to our newsletter."
    },
    "contact-form": {
      "header": "Contact us",
      "subheader": "The builder responds quickly, with no obligation.",
      "name": {
        "label": "Name",
        "placeholder": "Your name"
      },
      "email": {
        "label": "Email",
        "placeholder": "name{'@'}domain.com"
      },
      "telephone": {
        "label": "Phone",
        "placeholder": "(514) 555-1234"
      },
      "message": {
        "label": "Message",
        "placeholder": "Hello, I am interested in receiving more details, please contact me!"
      },
      "callback": {
        "label": "Callback",
        "asap": "As soon as possible",
        "tomorrow": "Tomorrow",
        "this-week": "This week"
      },
      "preference": {
        "label": "Preference",
        "anytime": "Anytime",
        "morning": "Morning",
        "day": "Day",
        "night": "Evening"
      },
      "subscribe": {
        "consent": "I want to subscribe",
        "subject": "to what's new!"
      },
      "send": "Send",
      "send-request": "Get more information",
      "validation": {
        "name-required": "Name is required.",
        "email-required": "Email is required.",
        "email-invalid": "Email is invalid.",
        "telephone-invalid": "Phone is invalid.",
        "captcha-failed": "Human validation failed."
      },
      "privacy-consent": "By submitting this form, I agree to the processing of my personal data in accordance with your ",
      "privacy-policy": "privacy policy",
      "success-message": "Your message has been sent!",
      "error": "A unexpected server error occured, please try again later."
    },
    "project-badge": {
      "new": "New Listing!",
      "sold": "Sold!"
    }
  },
  "views": {
    "home": {
      "title": "@:global.site-name {'|'} New houses & condos for sale",
      "meta": {
        "description": "Complete directory of new homes and condos for sale in the province of Quebec. Project New Home offers you the newest real estate available on the market."
      },
      "hero": {
        "project-image": "Project image: {name}",
        "quick-links": "Quick links"
      },
      "pathways": {
        "header": "What are you looking for?",
        "projects": {
          "title": "A real estate project",
          "description": "Browse every new construction project in Québec",
          "action": "Browse projects"
        },
        "builders": {
          "title": "A builder",
          "description": "Discover builders and their developments across Québec",
          "action": "View builders"
        },
        "assistance": {
          "title": "A search assistance service",
          "description": "Tell us what you are looking for and our team will help you for free",
          "action": "Make a request"
        },
        "guides": {
          "title": "Guides & Tips",
          "description": "Taxes, financing and home types: everything to buy new",
          "action": "Read the guides"
        }
      },
      "explore": {
        "regions": {
          "header": "Explore by region",
          "other": "Other",
          "show-cities": "Show all {count} cities",
          "show-fewer-cities": "Show fewer",
          "view-all": "See the project: {name} | See the project: {name} | See all {count} projects: {name}"
        }
      },
      "featured": {
        "header": "Discover our featured projects"
      }
    },
    "search": {
      "title": "{header} {'|'} @:global.site-name",
      "results": {
        "header": {
          "results": "Results",
          "distance": "Radius",
          "of-city": "of {name}",
          "of-region": "of the region of {name}",
          "region-genitive-default": "of {name}",
          "of-location": "of {name}"
        },
        "no-results": "Your search returned no results. Adjust your filters to find what you’re looking for.",
        "no-results-in-location": "No project matches your search in this location. Here are the closest projects.",
        "nearby": {
          "subject": "Projects",
          "subject-of-categories": "Projects of {categories}",
          "header": "{subject} near {name}",
          "header-of-region": "{subject} near the region of {name}",
          "loading": "Loading projects...",
          "load-more": "See more projects"
        },
        "starting-from": "From",
        "per-month": "per month",
        "studio": "Studio",
        "upon-request": "Price Upon Request",
        "pagination": {
          "previous": "Previous",
          "next": "Next"
        }
      },
      "placeholder": "Search for a city, region, project or builder",
      "placeholder-short": "City, region, project or builder",
      "price": "Price",
      "for-sale": "For Sale",
      "for-rent": "For Rent",
      "categories": "Categories",
      "filters": "Filters",
      "bedrooms": "Bedrooms",
      "studio-option": "Loft/Studio",
      "bathrooms": "Bathrooms",
      "button": "Search",
      "sections": {
        "locations": "Locations",
        "projects": "Projects",
        "builders": "Builders"
      },
      "near-me": {
        "label": "Use my location",
        "description": "Show suggestions near you first"
      },
      "pills": {
        "for-sale": "For Sale",
        "for-rent": "For Rent",
        "price-min-pill": "Price ≥ {value}",
        "price-max-pill": "Price ≤ {value}",
        "bedrooms-min-pill": "Bedrooms ≥ {value}",
        "bedrooms-max-pill": "Bedrooms ≤ {value}",
        "bedrooms-studio-pill": "Loft/Studio Only",
        "bathrooms-min-pill": "Bathrooms ≥ {value}",
        "bathrooms-max-pill": "Bathrooms ≤ {value}",
        "clear-all": "Clear All"
      }
    },
    "project": {
      "title": "{header} {'|'} @:global.site-name",
      "meta": {
        "title": "{name} {'|'} {propertyType} {priceType}",
        "title-in-location": "{name} {'|'} {propertyType} {priceType} in {location}"
      },
      "price-types": {
        "for-sale": "for sale",
        "for-rent": "for rent"
      },
      "property-types": {
        "houses": "New houses",
        "condos": "New condos",
        "multiplexes": "New multiplex homes",
        "manufactured-houses": "Prefab houses",
        "lands": "Lots and lands",
        "senior-residences": "Retirement homes"
      },
      "breadcrumbs": {
        "home": "Home",
        "return": "Back to search results"
      },
      "share": {
        "share": "Share",
        "facebook": "Facebook",
        "linked-in": "LinkedIn",
        "x": "X",
        "whatsapp": "Whatsapp",
        "email": "Email",
        "copy-link": "Copy link",
        "print": "Print"
      },
      "carousel": {
        "previous": "Previous Image",
        "next": "Next Image",
        "project": "Project"
      },
      "stats": {
        "starting-price": "Starting price",
        "bedrooms": "Bedrooms",
        "bathrooms": "Bathrooms",
        "floor-area": "Floor area",
        "loft-studio": "Loft/Studio",
        "range": "{min} to {max}",
        "upon-request": "Upon Request"
      },
      "anchors": {
        "label": "Page sections",
        "overview": "Overview",
        "models": "Homes",
        "details": "Details",
        "map": "Location",
        "builder": "Builder"
      },
      "action-bar": {
        "contact": "Get more information",
        "call": "Call",
        "starting-at": "From {price}"
      },
      "models": {
        "header": "Available homes",
        "sort": "Sort",
        "sort-default": "Suggested order",
        "sort-price-ascending": "Price (low to high)",
        "sort-price-descending": "Price (high to low)",
        "sort-bedrooms": "Bedrooms",
        "sort-floor-area": "Floor area",
        "studio": "Studio",
        "sold": "Sold",
        "starting-from": "From",
        "per-month": "per month",
        "per-month-short": "/ month",
        "upon-request": "Price Upon Request",
        "taxes-included": "(taxes included)",
        "taxes-excluded": "(taxes excluded)",
        "price-disclaimer": "Prices are subject to change without notice."
      },
      "model-dialog": {
        "close": "Close",
        "contact": "Request information"
      },
      "characteristics": {
        "header": "Characteristics",
        "bedrooms": "No Bedrooms | 1 Bedroom | {count} Bedrooms",
        "loft-studio": "Loft/Studio",
        "bedrooms-range": "{min} to {max} Bedroom | {min} to {max} Bedrooms",
        "bathrooms": "No Bathrooms | 1 Bathroom | {count} Bathrooms",
        "half-bathrooms": "No Half-Bathrooms | 1 Half-Bathroom | {count} Half-Bathrooms",
        "floor-area": "ft²"
      },
      "description": {
        "header": "Description",
        "document": "View the document",
        "multimedia": "View the multimedia presentation",
        "show-more": "Show more",
        "show-less": "Show less"
      },
      "contact": {
        "header": "Project",
        "form-header": "Learn more about this project",
        "website-link": "Visit the project website"
      },
      "calculator": {
        "header": "Mortgage Calculator",
        "purchase-price": "Purchase Price ($)",
        "down-payment": "Down Payment ($)",
        "interest-rate": "Interest Rate (%)",
        "amortization": "Amortization (years)",
        "term": "Term (years)",
        "payment-frequency": "Payment Frequency",
        "mortgage-amount": "Mortgage Amount",
        "payments": "Payments",
        "years": "0 years | {count} year | {count} years",
        "weekly": "Weekly",
        "bi-weekly": "Bi-weekly",
        "monthly": "Monthly",
        "weekly-suffix": "per week",
        "bi-weekly-suffix": "bi-weekly",
        "monthly-suffix": "per month",
        "legal-notice": "Legal Notice",
        "legal": "This online tool helps you estimate your mortgage payments based on the data you enter. The results are for informational purposes only and may vary depending on your financial situation. Calculations assume a constant interest rate and do not include mortgage default insurance premiums, which are required if the down payment is less than 20%. Please consult your lender for personalized advice."
      },
      "builder-projects": {
        "header": "Other projects by {builder}",
        "scroll-left": "Scroll Left",
        "scroll-right": "Scroll Right"
      },
      "nearby-projects": {
        "header": "Nearby projects",
        "scroll-left": "Scroll Left",
        "scroll-right": "Scroll Right"
      },
      "articles": {
        "header": "Articles about {name}",
        "all": "All articles by {builder} ({count})"
      }
    },
    "directory": {
      "title": "Directory {'|'} @:global.site-name",
      "header": "Directory",
      "no-results": "No results found."
    },
    "builder": {
      "title": "{subject} {'|'} @:global.site-name",
      "subject": "{name}, {category}",
      "subject-in-city": "{name}, {category} in {city}",
      "subject-in-city-region": "{name}, {category} in {city}, {region}",
      "subject-in-region": "{name}, {category} in {region}",
      "meta": {
        "description": "{subject}. Discover its new construction projects in Quebec.",
        "description-with-summary": "{subject}. {summary}"
      },
      "breadcrumb": {
        "home": "Home",
        "directory": "Directory"
      },
      "about": "About",
      "articles": "Articles about {name}",
      "projects": "Projects",
      "rbq-license": "RBQ License {license}",
      "contact-details": "Contact Details",
      "contact": "Contact: {name}",
      "see-active-builders": "Browse active builders by region"
    },
    "article": {
      "title": "{title} {'|'} @:global.site-name",
      "breadcrumb": {
        "directory": "Directory"
      },
      "published-on": "Published on {date}",
      "sponsored": "In collaboration with {builder}",
      "other-articles": "More articles by {builder}",
      "contact-header": "Learn more about {project}",
      "contact-button": "Get more information",
      "projects": "Featured project | Featured projects",
      "builder": "The builder",
      "builder-link": "View the {builder} page",
      "breadcrumb-home": "Home",
      "revised-on": "Updated on {date}",
      "by": "By {author}",
      "by-team": "By the {site} team",
      "reading-time": "{minutes} min read",
      "summary": "In brief",
      "toc": "Contents",
      "share": "Share",
      "share-facebook": "Share on Facebook",
      "share-linkedin": "Share on LinkedIn",
      "share-email": "Share by email",
      "share-copy": "Copy link",
      "share-copied": "Link copied",
      "share-native": "More sharing options",
      "toc-rail": "In this guide",
      "toc-remaining": "About {minutes} min left | About {minutes} min left",
      "toc-sections": "{count} section | {count} sections",
      "toc-progress": "Section {current} of {total}",
      "faq": "Frequently asked questions",
      "sources": "Sources ({count})",
      "author-guides": "See their guides",
      "guide-projects": "Projects",
      "guide-projects-button": "View the project | View the {count} projects",
      "other-guides": "More guides"
    },
    "guides": {
      "title": "Guides & Tips {'|'} @:global.site-name",
      "header": "Guides & Tips",
      "intro": "Clear answers for buying or building a new home in Quebec: home types, taxes, financing and warranties.",
      "featured": "Featured",
      "latest": "Latest guides",
      "categories": "Categories",
      "no-guides": "No guides published yet.",
      "find-project": {
        "title": "Find a project",
        "text": "Browse new home projects across Quebec.",
        "button": "View projects"
      },
      "category": {
        "title": "{title} {'|'} @:global.site-name",
        "guides": "{count} guide | {count} guides",
        "projects": "View projects"
      },
      "author": {
        "title": "{name}, {jobTitle} {'|'} @:global.site-name",
        "title-without-job": "{name} {'|'} @:global.site-name",
        "description": "Guides and tips written by {name} for {site}.",
        "job": "{jobTitle} · {site}",
        "profile": "View profile",
        "guides": "Guides by {name}"
      },
      "related": {
        "header": "Related guides",
        "all": "All guides"
      }
    },
    "about": {
      "title": "About {'|'} @:global.site-name"
    },
    "advertise": {
      "title": "Advertise {'|'} @:global.site-name",
      "header": "Make Your Project Known with Project New Home"
    },
    "privacy": {
      "title": "Privacy Policy {'|'} @:global.site-name"
    },
    "support": {
      "title": "Support {'|'} @:global.site-name",
      "header": "Need help or have suggestions?"
    },
    "terms": {
      "title": "Terms of Use Policy {'|'} @:global.site-name"
    },
    "profile": {
      "confirmation-banner": {
        "message": "Your subscription to \"{subscription}\" has been confirmed.",
        "subscriptions": {
          "Newsletters": "Newsletters",
          "NewListingAlerts": "New Listing Alerts"
        }
      }
    },
    "profile-login": {
      "title": "Profile Login {'|'} @:global.site-name",
      "meta": {
        "description": "Securely opening your profile..."
      },
      "header": "Opening your profile",
      "message": "Please wait while we validate your secure link..."
    },
    "profile-login-error": {
      "title": "Profile Link Error {'|'} @:global.site-name",
      "meta": {
        "description": "Your secure profile link could not be validated."
      },
      "eyebrow": "Profile",
      "header": "Your secure link is invalid or expired",
      "message": "Open the latest link from your email again, or contact support if the problem continues.",
      "home-link": "Go to home page",
      "support-link": "Contact support"
    },
    "subscriptions": {
      "title": "Subscriptions {'|'} @:global.site-name",
      "meta": {
        "description": "Manage your Project New Home subscription preferences."
      },
      "eyebrow": "Profile",
      "header": "Manage your subscriptions",
      "message": "Control your newsletters and new listing alerts from this secure profile.",
      "loading": "Loading your subscription profile...",
      "saving": "Saving...",
      "removing": "Removing...",
      "saved": "Your changes have been saved.",
      "errors": {
        "generic": "We could not update your subscriptions. Please try again."
      },
      "newsletter": {
        "title": "Newsletters",
        "description": "Receive occasional newsletters from us and relevant offers from our partners.",
        "enable": "Enable newsletters",
        "disable": "Disable newsletters",
        "disable-confirm": "Are you sure you want to stop receiving newsletter emails for this address?"
      },
      "unsubscribe-all": {
        "title": "Unsubscribe",
        "description": "Unsubscribe from newsletters and all new listing alerts.",
        "button": "Unsubscribe from all",
        "cancel": "Cancel",
        "confirm": "Are you sure you want to unsubscribe from newsletters and all new listing alerts?",
        "saved": "You have been unsubscribed from all subscriptions."
      },
      "alerts": {
        "title": "New Listing Alerts",
        "description": "Tell us where to look, and we’ll let you know when new listings show up.",
        "add": "Add alert",
        "empty": "You do not have any new listing alerts yet.",
        "item-title": "Alerts for {name}",
        "summary-title": "Alerts for {name} within {distance}",
        "summary-title-with-categories": "Alerts for {categoriesList} in {name} within {distance}",
        "location-fallback": "selected location",
        "map-title": "Location",
        "map-help": "Move the marker or click the map to choose the centre of this alert.",
        "distance": "Distance",
        "distance-help": "Choose how far from the selected location this alert should watch.",
        "distance-option": "{distance} km",
        "categories": "Categories",
        "categories-help": "Select one or more categories to focus this alert.",
        "categories-list-conjunction": "and",
        "edit": "Edit alert",
        "save": "Save alert",
        "remove": "Remove alert",
        "remove-title": "Remove alert for {name}",
        "remove-confirm": "Are you sure you want to remove this new listing alert?"
      },
      "map": {
        "error": "The map could not be loaded. Please try again later."
      }
    },
    "not-found": {
      "title": "Page Not Found {'|'} @:global.site-name",
      "header": "This page was not found...",
      "message": "The page you requested could not be found.",
      "redirect-message": "Redirecting to the home page in {seconds} seconds.",
      "home-link": "Return to home page now"
    },
    "editorial": {
      "title": "Editorial {'|'} @:global.site-name",
      "header": "Editorial",
      "intro": "Explore construction projects in Quebec, by property type and by region.",
      "meta": {
        "description": "Discover our editorial content covering topics about new construction projects, real estate trends, and housing market insights."
      },
      "no-categories": "No editorial categories available at this time.",
      "category": {
        "title": "{title} {'|'} @:global.site-name",
        "locations": "{title} by region",
        "advantages": "Advantages of {title}"
      },
      "no-locations": "No editorial locations available at this time.",
      "location": {
        "title": "{title} {'|'} @:global.site-name",
        "child-locations": "{title} by city",
        "choose-city": "Choose a city",
        "advantages": "Advantages of {title}",
        "view-builders": "View the builders {locationPhrase}",
        "view-builders-generic": "View the builders",
        "laval": {
          "intro": {
            "p1-stats": "@:global.site-name currently features {count} new house projects for sale in Laval, in areas such as Duvernay, Auteuil, Sainte-Dorothée and Chomedey, starting from {minPrice}.",
            "p1": "@:global.site-name features new house projects for sale in Laval, in areas such as Duvernay, Auteuil, Sainte-Dorothée and Chomedey.",
            "p2": "This page lists the active projects published on our portal by builders, with their models and prices, continuously updated."
          },
          "price": {
            "header": "How much does a new house cost in Laval?",
            "p1-stats": "Prices for new houses for sale in Laval start from {minPrice} for the projects listed on our portal. The final price varies by area, lot size, chosen model and the inclusions offered by the builder.",
            "p1": "The price of a new house in Laval varies by area, lot size, chosen model and the inclusions offered by the builder.",
            "p2": "Prices advertised by builders often exclude sales taxes (GST and QST), which apply to new properties. A partial tax rebate may apply depending on the price of the house: check with the builder before signing."
          },
          "sectors": {
            "header": "In which areas of Laval can you find a new house?",
            "intro": "New house projects are concentrated in a few areas of Laval, each with its own character.",
            "duvernay": "{link} borders the Rivière des Prairies in eastern Laval and offers direct access to Highway 25 toward Montreal.",
            "sainte-dorothee": "{link}, on the western side of the island, attracts families with its recent developments near Highway 13.",
            "auteuil": "{link}, to the north, offers larger lots in a quiet residential setting.",
            "chomedey": "{link} is home to Laval's main commercial hubs, including Carrefour Laval and Centropolis."
          },
          "why": {
            "header": "Why buy a new house in Laval?",
            "p1": "Choosing a new house in Laval means buying a never-lived-in property, built to current insulation and energy-efficiency standards, in a city that combines urban services with established residential neighbourhoods.",
            "warranty": "Mandatory protection: the Guarantee Plan for New Residential Buildings (GCR) protects your deposits and covers poor workmanship and certain defects for several years after delivery.",
            "location": "A strategic position between Montreal and the North Shore, served by highways 13, 15, 19, 25 and 440.",
            "transport": "Three metro stations (Cartier, De la Concorde and Montmorency) and commuter train stations to reach Montreal without a car.",
            "lifestyle": "Schools, parks such as the Centre de la nature and commercial hubs including Carrefour Laval, minutes away from residential neighbourhoods.",
            "p2": "A new project also lets you customize finishes depending on the construction phase and reduces the renovations to plan for during the first years."
          },
          "faq": {
            "header": "Frequently asked questions about new houses in Laval",
            "types": {
              "question": "What types of new houses are available in Laval?",
              "answer": "You will find bungalows, cottages, semi-detached houses, townhouses, intergenerational houses and prefabricated houses. Use the type filter at the top of the page to narrow down the list of projects."
            },
            "warranty": {
              "question": "Which warranty protects the purchase of a new house in Quebec?",
              "answer": "The Guarantee Plan for New Residential Buildings (GCR) is mandatory for new houses sold by a contractor in Quebec. It notably protects your deposits and covers poor workmanship and certain defects for several years after you take possession."
            },
            "taxes": {
              "question": "Are taxes included in the advertised price?",
              "answer": "Rarely. New house prices are generally advertised before sales taxes (GST and QST). A partial tax rebate may apply depending on the price of the property: confirm the final amount with the builder."
            },
            "delivery": {
              "question": "What is the delivery time for a new house in Laval?",
              "answer": "It depends on the project's progress: an already-built house can be delivered within weeks, while building from plans generally takes several months to over a year. Each project page shows how to reach the builder for actual timelines."
            }
          }
        }
      },
      "statistics": {
        "header": "{title}: Market Figures",
        "summary": "{title}: {projects}, {builders}.",
        "summary-projects": "no listed projects | {count} listed project | {count} listed projects",
        "summary-builders": "no builders | offered by {count} builder | offered by {count} builders",
        "summary-types": "Prices advertised by the builders: {types}.",
        "summary-type-entry": "{name} from {price}",
        "summary-bedrooms": "By bedroom count: {bedrooms}.",
        "summary-bedroom-entry": "{n} bedroom from {price} | {n} bedroom from {price} | {n} bedrooms from {price}",
        "summary-studio-entry": "Loft/Studio from {price}",
        "summary-amenities": "Most common features: {amenities}.",
        "summary-amenity-entry": "{name} in no project | {name} in {count} project | {name} in {count} projects",
        "summary-updated": "Updated {date}.",
        "tables-toggle": "See the comparison tables",
        "types-table": {
          "header": "Prices by property type",
          "type": "Type",
          "projects": "Projects",
          "bedrooms": "Bedrooms",
          "price-range": "Price range",
          "floor-area": "Floor area",
          "price-per-square-foot": "Median price per sq. ft.",
          "floor-area-value": "{median} sq. ft.",
          "range": "{minimum} to {maximum}"
        },
        "lots-table": {
          "header": "Lots",
          "type": "Type",
          "projects": "Projects",
          "price-range": "Price range",
          "floor-area": "Lot area",
          "price-per-square-foot": "Median price per sq. ft. of land"
        },
        "projects-table": {
          "header": "Listed projects",
          "caption": "A selection of projects listed on {siteName}, in the same order as the list above.",
          "project": "Project",
          "type": "Type",
          "bedrooms": "Bedrooms",
          "bathrooms": "Bathrooms",
          "floor-area": "Floor area",
          "starting-price": "From",
          "bedroom-column": "no bedroom | {n} bedroom | {n} bedrooms",
          "builder": "Builder"
        },
        "faq": {
          "header": "Frequently asked questions about new properties {locationPhrase}",
          "header-generic": "Frequently asked questions about new properties",
          "types": {
            "question": "What types of new properties are available {locationPhrase}?",
            "question-generic": "What types of new properties are available here?",
            "answer": "Listed projects currently offer: {types}. Use the type filter at the top of the page to narrow the list of projects."
          },
          "warranty": {
            "question": "Which warranty protects the purchase of a new property in Quebec?",
            "answer": "The Garantie de construction résidentielle (GCR) is mandatory for new homes sold by a contractor in Quebec. It notably protects your deposits and covers poor workmanship and certain defects for several years after the home is delivered."
          },
          "taxes": {
            "question": "Are taxes included in the advertised prices?",
            "answer": "Rarely. New property prices are generally advertised before sales taxes (GST and QST). A partial rebate of those taxes may apply depending on the price of the property: confirm the final amount with the builder."
          },
          "delivery": {
            "question": "What is the delivery time for a new property {locationPhrase}?",
            "question-generic": "What is the delivery time for a new property?",
            "answer": "The delivery time depends on the progress of the project: an already built home can be delivered within weeks, while building from plans generally takes several months to more than a year. Each project page explains how to reach the builder for actual timelines."
          }
        },
        "sources": "Prices advertised by the builders, generally before taxes (GST and QST); the price per square foot is calculated on before-tax prices only. External sources: {gcr} and {revenuQuebec}.",
        "sources-gcr": "Garantie de construction résidentielle (GCR)",
        "sources-revenu-quebec": "Revenu Québec"
      },
      "map": {
        "show": "Show map",
        "hide": "Show list",
        "view-project": "View project",
        "pending-address": "Address to be determined",
        "pending-address-description": "These projects are not yet precisely located on the map.",
        "error": "The map could not be loaded."
      },
      "breadcrumb": {
        "home": "Home",
        "editorial": "Editorial"
      },
      "view-regions": "View regions",
      "view-projects": "View projects",
      "view": "View {title}",
      "no-image": "No Image",
      "search-results": {
        "header": "Projects of {title}",
        "loading": "Loading projects...",
        "load-more": "See more projects",
        "no-results": "No projects found for {title} at this time.",
        "filter-label": "Filter by type",
        "filter-clear": "Show all",
        "default": "Projects"
      },
      "nearby-search-results": {
        "loading": "Loading projects in the area...",
        "no-results": "No other projects found in the area for {title} at this time.",
        "title": "Other projects in the area"
      },
      "help-widget": {
        "title": "We can still help you find what you are looking for",
        "description": "No project matches here, but our team can search for you among projects that are not listed on the site. Tell us what you are looking for and we will contact you.",
        "cta": "Get free help",
        "modal-title": "Describe what you are looking for",
        "modal-description": "The more you tell us, the better we can help. Only name, email and telephone are required.",
        "name": {
          "label": "Name",
          "placeholder": "Your name"
        },
        "email": {
          "label": "Email",
          "placeholder": "name{'@'}domain.com"
        },
        "telephone": {
          "label": "Telephone",
          "placeholder": "514 555-1234"
        },
        "search-location": {
          "label": "Where are you looking?",
          "placeholder": "City, region or area"
        },
        "property-type": {
          "label": "Property type",
          "house": "House",
          "condo": "Condo",
          "apartment": "Apartment",
          "plex": "Plex",
          "land": "Land",
          "other": "Other"
        },
        "transaction-type": {
          "label": "Transaction",
          "buy": "Buy",
          "rent": "Rent"
        },
        "budget": {
          "label": "Budget",
          "placeholder": "e.g. $400,000 - $500,000"
        },
        "bedrooms": {
          "label": "Bedrooms"
        },
        "bathrooms": {
          "label": "Bathrooms"
        },
        "timeline": {
          "label": "Timeline",
          "immediately": "Immediately",
          "three-months": "Within 3 months",
          "six-months": "Within 6 months",
          "one-year": "Within 1 year",
          "flexible": "Flexible"
        },
        "preferred-contact": {
          "label": "Preferred contact",
          "phone": "Telephone",
          "email": "Email",
          "either": "Either"
        },
        "comments": {
          "label": "Comments",
          "placeholder": "Specify your needs (parking, number of floors, neighbourhood, etc.)"
        },
        "consent": "I agree to be contacted by Project New Home about my search.",
        "select-default": "Not specified",
        "cancel": "Cancel",
        "send": "Send my request",
        "sending": "Sending...",
        "close": "Close",
        "success-title": "Request sent!",
        "success-message": "Thank you! Our team will contact you shortly to help with your search.",
        "privacy-consent": "By submitting this form, I agree to the processing of my personal data in accordance with your ",
        "privacy-policy": "privacy policy",
        "error": "An unexpected server error occurred, please try again later.",
        "validation": {
          "name-required": "Name is required.",
          "email-required": "Email is required.",
          "email-invalid": "Email is invalid.",
          "telephone-required": "Telephone is required.",
          "telephone-invalid": "Telephone is invalid.",
          "consent-required": "Your consent is required.",
          "captcha-failed": "Human validation failed."
        }
      }
    },
    "builders": {
      "root": {
        "title": "Home and Condo Builders in Quebec {'|'} @:global.site-name",
        "header": "Home and Condo Builders in Quebec",
        "intro": "Every builder here has at least one project underway. Pick a property type and a region to see who is building near you.",
        "meta": {
          "description": "Discover the builders with a project underway in Quebec, by property type and region. New houses, condos and lots."
        },
        "loading": "Loading builders...",
        "builders": "0 builders | {count} builder | {count} builders",
        "category-summary": "{builders} across {locations}",
        "regions": "0 regions | {count} region | {count} regions",
        "directory-title": "Looking for a specific company?",
        "directory-description": "The directory lists every registered company across all trades, whether or not it has a project underway.",
        "directory-link": "Browse the full directory",
        "no-results": "No builder has a project underway at this time."
      },
      "location": {
        "title": "Builders {locationPhrase}: Compare {countText} of {category} {'|'} @:global.site-name",
        "title-generic": "Builders of {subject} {'|'} @:global.site-name",
        "header": "Builders of {category} {locationPhrase}",
        "header-generic": "Builders of {subject}",
        "intro": "All these builders currently have a project underway in {locationName}.",
        "meta": {
          "description": "Compare {countText} of {category} {locationPhrase}. Browse their current projects and find the right builder.",
          "description-generic": "Discover the builders of {subject}. Compare what they offer and browse their projects."
        },
        "builders-count": "0 builders | {count} builder | {count} builders",
        "featured": "Featured builders",
        "all": "All builders",
        "projects": "0 projects | {count} project | {count} projects",
        "loading": "Loading builders...",
        "no-results": "No builders found for {subject} at this time.",
        "no-logo": "No logo",
        "view-builder": "View {name}'s profile",
        "view-projects": "View projects in {locationName}",
        "view-projects-unprefixed": "View projects in {locationName}"
      },
      "breadcrumb": {
        "home": "Home",
        "builders": "Builders"
      }
    },
    "ad-unit": {
      "title": "Your Ad {'|'} @:global.site-name",
      "header": "Your Ad"
    }
  },
  "footer": {
    "tag-line": "The #1 website to find new constructions homes for sale in Quebec.",
    "copyright": "All rights reserved.",
    "categories": {
      "projects": {
        "title": "Real Estate Projects",
        "houses-for-sale": {
          "title": "New Houses For Sale",
          "category-slug": "new-houses-for-sale"
        },
        "condos-for-sale": {
          "title": "New Condos For Sale",
          "category-slug": "new-condos-for-sale"
        },
        "condos-for-rent": {
          "title": "New Condos For Rent",
          "category-slug": "new-condos-for-rent"
        }
      },
      "help": {
        "title": "Help",
        "support": {
          "title": "Support"
        },
        "advertise": {
          "title": "Advertise"
        }
      },
      "company": {
        "title": "Company",
        "directory": {
          "title": "Directory"
        },
        "builders": {
          "title": "Builders"
        },
        "about": {
          "title": "About us"
        },
        "editorial": {
          "title": "Editorial"
        },
        "guides": {
          "title": "Guides & Tips"
        }
      },
      "legal": {
        "title": "Legal",
        "privacy": {
          "title": "Privacy"
        },
        "terms": {
          "title": "Terms"
        }
      }
    }
  }
}
